import { render, staticRenderFns } from "./Intro.vue?vue&type=template&id=fa687558&scoped=true&"
import script from "./Intro.vue?vue&type=script&lang=js&"
export * from "./Intro.vue?vue&type=script&lang=js&"
import style0 from "./Intro.vue?vue&type=style&index=0&id=fa687558&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa687558",
  null
  
)

export default component.exports